import 'rc-slider/assets/index.css'
import 'rc-tooltip/assets/bootstrap.css'
import './styles.scss'
import React from 'react'
// import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider'

const handleStyle = {
  border: '2px solid #dd601d',
  width: 25,
  height: 25,
  backgroundColor: '#fff',
  outline: 'none',
}

const rangeStyle = {
  railStyle: {
    height: 6,
    marginTop: 5,
  },
  trackStyle: {
    backgroundColor: '#dd601d',
    height: 6,
    marginTop: 5,
  },
  handleStyle,
}

export default class Index extends React.Component {
  state = {
    value: this.props.initialValue || 0,
  }

  handleChange = (value) => this.setState({ value })

  render() {
    const { value } = this.state
    const { name, getLabel, ...rest } = this.props
    return (
      <div className='nx-slider'>
        <small>{getLabel(value)}</small>
        <Slider
          onChange={this.handleChange}
          onAfterChange={(val) => this.props.handleChange({ [name]: val })}
          value={value}
          {...rest}
          {...rangeStyle}
        />
      </div>
    )
  }
}
